
import { Vue, Component } from "vue-property-decorator";
import { OperationsManagementService} from "@/api/service-proxies";
@Component({})
export default class SchoolSelector extends Vue {
  tenantId: string | null = null;
  tenants = []; // 原始数据
  filteredTenants = []; // 过滤后的数组
OperationPointsService = new OperationsManagementService()
  created() {
    this.getData();
  }

  getData() {
 this.OperationPointsService.getCanWorkSchools(0).then((result: any) => {
      this.tenants = result.items || [];
      this.filteredTenants = [...this.tenants]; // 初始化过滤数组
    }).catch(err => {
      console.error("获取学校数据失败：", err);
    });
  }

  // 自定义过滤方法：模糊匹配，忽略大小写
  filterMethod(query: string) {
    if (!query) {
      // 如果搜索为空，显示所有数据
      this.filteredTenants = [...this.tenants];
      return;
    }
    // 模糊匹配：包含搜索词（忽略大小写）
    this.filteredTenants = this.tenants.filter((item: any) => {
      return item.name && item.name.toLowerCase().includes(query.toLowerCase());
    });
  }

  change() {
    this.$emit("change", {
      tenantId: this.tenantId,
    });
  }
}
